import React from "react";
import { motion } from "framer-motion";
import { Wallet, TrendingUp, CreditCard, Landmark } from "lucide-react";
import { fmt } from "../../lib/game";

const KPIS = [
  { id: "cash", label: "Cash", Icon: Wallet, accent: "text-emerald-400", ring: "border-emerald-500/30", testid: "kpi-cash" },
  { id: "investments", label: "Investments", Icon: TrendingUp, accent: "text-purple-400", ring: "border-purple-500/30", testid: "kpi-investments" },
  { id: "debts", label: "Total Debt", Icon: CreditCard, accent: "text-red-400", ring: "border-red-500/30", testid: "kpi-debts" },
  { id: "net_worth", label: "Net Worth", Icon: Landmark, accent: "text-blue-400", ring: "border-blue-500/30", testid: "kpi-net-worth" },
];

export const Dashboard = ({ session, flashKeys = [] }) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
      {KPIS.map(({ id, label, Icon, accent, ring, testid }) => {
        const flashing = flashKeys.includes(id);
        return (
          <motion.div
            key={id}
            data-testid={testid}
            animate={
              flashing
                ? { scale: [1, 1.05, 1], boxShadow: ["0 0 0px rgba(16,185,129,0)", "0 0 24px rgba(16,185,129,0.35)", "0 0 0px rgba(16,185,129,0)"] }
                : {}
            }
            transition={{ duration: 0.8 }}
            className={`relative rounded-2xl border ${ring} bg-slate-900/70 backdrop-blur px-4 py-3.5 overflow-hidden`}
          >
            <div className="flex items-center gap-2 mb-1.5">
              <Icon className={`w-4 h-4 ${accent}`} />
              <span className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">
                {label}
              </span>
            </div>
            <p className={`font-mono text-lg sm:text-2xl font-bold whitespace-nowrap tabular-nums ${id === "debts" && session[id] > 0 ? "text-red-300" : "text-slate-100"}`}>
              {id === "debts" && session[id] > 0 ? `-${fmt(session[id]).replace("-", "")}` : fmt(session[id])}
            </p>
          </motion.div>
        );
      })}
    </div>
  );
};
